/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=29975cf2"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29975cf2')) {
      api.createRecord('29975cf2', component.options)
    } else {
      api.reload('29975cf2', component.options)
    }
    module.hot.accept("./ChatIcon.vue?vue&type=template&id=29975cf2", function () {
      api.rerender('29975cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/ChatIcon.vue"
export default component.exports